/**
 * cn — className joiner used by the design-system primitives
 * (button / badge / card). Mirrors `@/lib/utils` from zworks-router-v2
 * so the same component code can be ported between apps verbatim.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
